module.exports = __webpack_public_path__ + "static/media/evening-snack.e9352e56.png";